import { FormEvent, useMemo, useState } from "react";
import { Layout } from "../components/Layout";
import { Panel } from "../components/Panel";
import { setPasswordWithSetupToken } from "../lib/api/adminUsersClient";
import { t, useWorkspaceLanguage, withLanguagePrefix } from "../lib/i18n";

export function SetupPassword() {
  const language = useWorkspaceLanguage();
  const labels = t(language).setupPassword;
  const token = useMemo(() => new URLSearchParams(window.location.search).get("token") ?? "", []);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState<string | undefined>();
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setMessage(undefined);
    if (!token) {
      setMessage(labels.missingToken);
      return;
    }
    if (password !== confirmPassword) {
      setMessage(labels.mismatch);
      return;
    }
    setIsSubmitting(true);
    const result = await setPasswordWithSetupToken(token, password);
    setIsSubmitting(false);
    setMessage(result.message);
    setSuccess(result.ok);
  }

  return (
    <Layout
      title={labels.title}
      description={labels.description}
    >
      <Panel title={success ? labels.readyTitle : labels.newPasswordTitle} variant="accent">
        {success ? (
          <div className="question-flow">
            <p>{labels.readyBody}</p>
            <a className="button button-primary" href={withLanguagePrefix("/login", language)}>
              {labels.loginCta}
            </a>
          </div>
        ) : (
          <form className="form" onSubmit={handleSubmit}>
            <label htmlFor="password">{labels.password}</label>
            <input
              id="password"
              type="password"
              minLength={12}
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            <label htmlFor="confirm-password">{labels.confirmPassword}</label>
            <input
              id="confirm-password"
              type="password"
              minLength={12}
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              required
            />
            <p className="form-note">{labels.note}</p>
            {message ? <p className="form-error" role="alert">{message}</p> : null}
            <button className="button button-primary" type="submit" disabled={isSubmitting}>
              {labels.submit}
            </button>
          </form>
        )}
      </Panel>
    </Layout>
  );
}
